import { IResourceComponentsProps, useExport, useNavigation, useShow } from '@pankod/refine-core'
import { EvaluationList } from 'components/evaluations'
import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  useTable,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  ShowButton,
  Typography,
} from '@pankod/refine-antd'

import { IEvaluationMain } from 'interfaces'
// import { CreateTestEvent } from './create'
// import { EditTestEvent } from './edit'
const { PlusOutlined } = Icons
const { Text, Link } = Typography

export const Evaluation: React.FC<IResourceComponentsProps> = () => {
  const { triggerExport, isLoading } = useExport<IEvaluationMain>()
  return <EvaluationList record={{}} />
}
